import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { General } from "../../interfaces/general";
import { ServiciosGeneralesService } from 'projects/modulo-solicitudes/src/core/servicios/servicios-generales.service';
import { FormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
	selector: "app-madre",
	templateUrl: "./madre.component.html",
	styleUrls: ["./madre.component.css"],
})
export class MadreComponent implements OnInit {
	@Input() catalogos: General;
	@Input() estados: Array<any>;
	@Input() DatosMadre: FormGroup;
	@Input() listaCURPS: Array<any>
	@Input() curpSolicitante: string
	@Output() conCurp = new EventEmitter()

	loading = false;
	tieneCURP = false;
	paises: any;
	tipoPersona = 1;
	extranjeroEs = false;
	pais: string;
	municipios: Array<any>;
	constructor(private serviciosGenerales: ServiciosGeneralesService,
				private snackBar: MatSnackBar) {}


	ngOnInit(): void {
		this.escucharCURP()
		this.listarMunicipios(this.DatosMadre.value.Personas_EntidadFederativaID)
		this.DatosMadre.get('Personas_Nombre').disable()
		this.DatosMadre.get('Personas_Nombre').disable()
		this.DatosMadre.get('Personas_ApellidoPaterno').disable()
		this.DatosMadre.get('Personas_ApellidoMaterno').disable()
		this.DatosMadre.get('Personas_Genero').disable()
		this.DatosMadre.get('Personas_EntidadFederativaID').disable()
		this.DatosMadre.get('Personas_MunicipioID').disable()
	}

	escucharCURP() {
		this.DatosMadre.get("Personas_CURP")
			.valueChanges.pipe(debounceTime(1500))
			.subscribe((CURP) => {
				return CURP.length === 18 &&
						this.listaCURPS.filter(value => value === CURP).length === 0 &&
						this.curpSolicitante !== CURP
										? this.obtenerdatosCURP(CURP) :
										this.openSnackBar('Esta CURP ya fue registrada en esta solicitud','Entendido');
			});
	}
	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
		duration: 2000,
		});
	}
	obtenerPaises(): void {
		this.serviciosGenerales.listadoPaises().subscribe((res) => {
			this.paises = res;
			const pais = this.paises.filter(
				(pais) => pais.ISO_A3 === this.pais
			);
			this.DatosMadre.get("Personas_PaisID").setValue(pais.ID);
		});
	}
	idEstadoMunicipioCURP (estadoID, MunicipioID) {
		const idEstadoDB = this.estados.filter(estado => +estado.Codigo === +estadoID)
		console.log(idEstadoDB)
		this.serviciosGenerales.listadoMunicipios(idEstadoDB[0].ID).subscribe((res) => {
			this.municipios = res
			const idMunicipioID = this.municipios.filter(municipio => +municipio.Codigo === +MunicipioID)
			this.DatosMadre.get('Personas_EntidadFederativaID').setValue(idEstadoDB[0].ID);
			this.DatosMadre.get('Personas_MunicipioID').setValue(idMunicipioID[0].ID);
		});
	}
	listarMunicipios(idEstado: number) {

		this.serviciosGenerales.listadoMunicipios(idEstado).subscribe((res) => {
			this.municipios = res;
		});
	}
	obtenerdatosCURP(CURP: string) {
		this.tieneCURP = false;
		this.cleanForm();
		this.serviciosGenerales.obtenerDatosCURP(CURP).subscribe((res) => {

				this.tieneCURP = res.Ok;
				if(this.tieneCURP) {
					if(res.Data.Genre === 'M') {
						// this.DatosMadre.reset()
						if(res.Data.Country === "MEX") {
							this.mostrarInformacion(res.Data)
							// this.obtenerListaEstadosID()
							this.extranjeroEs = false;
						} else {
							this.pais = res.Data.Country
							this.extranjeroEs = true;
							this.mostrarInformacion(res.Data)
							this.obtenerPaises();
						}
					} else {
						this.openSnackBar("La CURP ingresada debe pertenecer a una Mujer",'Entendido')
					}

				} else {
					this.openSnackBar('CURP no valida', 'Entendido')
				}
		})
	}

	mostrarInformacion(persona) {

		if (persona !== undefined) {
			if(persona.Country === "MEX") {
				this.idEstadoMunicipioCURP(+persona.StateId, persona.CityId)
			}
			else {
				this.DatosMadre.get('Personas_EntidadFederativaID').setValue(1001);
			}
			this.DatosMadre.get('Personas_Nombre').setValue(persona.Name);
			this.DatosMadre.get('Personas_ApellidoPaterno').setValue(persona.Lastname);
			this.DatosMadre.get('Personas_ApellidoMaterno').setValue(persona.Surname);
			this.DatosMadre.get('Personas_Genero').setValue(persona.Genre);
			this.getFecha(persona.BirthDate)
			this.conCurp.emit()
		}
	}
	getFecha (fecha:string) {
		const datos = fecha.split('/')
		const ano = datos[2]
		const mes = datos[1]
		const dia = datos[0]
		const nuevaFecha = `${ano}-${mes}-${dia}T00:00:00`
		this.DatosMadre.get('Personas_FechaNacimiento').setValue(nuevaFecha)
		const fechaCumpleanos = this.calculateAge(new Date(+ano,+mes,+dia))
		this.DatosMadre.get('Personas_Edad').setValue(fechaCumpleanos)
	}
	calculateAge(birthday) {
		const ageDifMs = Date.now() - birthday.getTime();
		const ageDate = new Date(ageDifMs);
		return Math.abs(ageDate.getUTCFullYear() - 1970);
	}

	cleanForm(){
		this.DatosMadre.get('Personas_EstadoCivilID').setValue(0);
	}
}
